export default __webpack_public_path__ + "static/media/gallery_09.5164c5d5.jpg";